import { render, staticRenderFns } from "./EditDialogEventMainContainer.vue?vue&type=template&id=3c3ca384&scoped=true"
import script from "./EditDialogEventMainContainer.vue?vue&type=script&lang=js"
export * from "./EditDialogEventMainContainer.vue?vue&type=script&lang=js"
import style0 from "./EditDialogEventMainContainer.vue?vue&type=style&index=0&id=3c3ca384&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c3ca384",
  null
  
)

export default component.exports